import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useAuth } from '../../auth'
import { useAppSelector } from '../../../../redux/hooks'
const API_URL = process.env.REACT_APP_API_URL



const Modalmail = ( props:any ) => {
  const [Nombre,setNombre] = useState('');
  const [email,setEmail] = useState('');
  const [telefono,setTelefono] = useState('');
  const [Company,setCompany] = useState('');
  const [Jobtitle,setJobtitle] = useState('');
  const [commentary,setCommentary]=useState('')
  const [product,setproduct]=useState('')
  const [showModal, setShowModal] = useState(true); // Estado para controlar la visibilidad del modal

  const tenant= useAppSelector(state =>state.TenantSlice.id)


  const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{

      
        const body ={
          product:product,
          commentary:commentary,
          
        }
        if(tenant===0){
        await axios.post(API_URL+'/v1/contact/newfeature', body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Tu solicitud ha sido enviada',
          showConfirmButton: false,
          timer: 1500
        
        });
         // Cerrar el modal después de enviar el formulario
         setShowModal(false);

      });
      }
      else{
        await axios.post(API_URL+'/v1/contact/newfeature', body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Tu solicitud ha sido enviada',
          showConfirmButton: false,
          timer: 1500
        });
         // Cerrar el modal después de enviar el formulario
         setShowModal(false);
      })
      }
      //navigate('/support/SeeRequest')
    
  }
    catch(error:any){
      console.log(error)

    }

    
   }
  return (
    
    <>
    

      {showModal &&props.id === null &&
      <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form'  onSubmit={handleSubmit}>
                                {/* begin::Heading */}
                                {/*<Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
      description=''></Card4>*/}
                                <div className='text-center mb-5'>
                                <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Contact Us</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                                <div className='mb-2 bg-light-marino p-8 rounded f-parrafo'>
                                    <div className='text-marino'>
                                    Once completed, a sales representative will reach out to you to discuss your needs and provide you with further information about our products and services. Thank you for your interest in our company.
                                    </div>
                                </div>

                               {/* <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="name">Name</label>
                                   <input type="text" 
                                   required
                                   name='name' 
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   id='Nombre'
                                   value={Nombre}
                                   onChange={(e:any) => setNombre(e.target.value)}
                                   />
    </div>*/}

                            {/*    <div className='row'>
                                  <div className='col'>
                                    <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="email">Email</label>
                                    <input type="email"
                                    required 
                                    name='email' 
                                    className='form-control form-control-solid border-gray-300 f-parrafo' 
                                    id='email'
                                    value={email}
                                    onChange={(e:any) => setEmail(e.target.value)}
                                    />
                                  </div>
                                  <div className='col'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="email">Phone Number</label>
                                    <input type="tel" 
                                    required
                                    name='tel' 
                                    className='form-control form-control-solid border-gray-300 f-parrafo' 
                                    id='tel'
                                    value={telefono}
                                    onChange={(e:any) => setTelefono(e.target.value)}
                                    />

                                  </div>

  </div>*/}

                               { /*<div className='row'>
                                  <div className='col'>
                                    <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="company">Company</label>
                                    <input type="text"
                                    required 
                                    name='company' 
                                    className='form-control form-control-solid border-gray-300 f-parrafo' 
                                    id='company'
                                    value={Company}
                                    onChange={(e:any) => setCompany(e.target.value)}
                                    />
                                  </div>
                                  <div className='col'>
                                  <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo required' htmlFor="position">Position within the Company:</label>
                                    <input type="text" 
                                    required
                                    name='position' 
                                    className='form-control form-control-solid border-gray-300 f-parrafo' 
                                    id='position'
                                    value={Jobtitle}
                                    onChange={(e:any) => setJobtitle(e.target.value)}
                                    />

                                  </div>
                                </div>
*/}
                                  <div >
                                    <label className='form-label fw-bolder text-marino fs-6 mb-0 f-parrafo required' htmlFor="company">Product/Service of interest</label>
                                    <select 
                                     required
                                     id='Prioridad'
                                     value={product}
                                     onChange={(e) => setproduct(e.target.value)}

                                    className="form-select form-select-solid bg-light-info border-gray-300 " aria-label="Select example">
                                      <option selected hidden>Select</option>
                                      <option  value="Fortinet Solutions">Fortinet Solutions</option>
                                      <option  value="Fortinet Solutions">CTX HUB</option>
                                      <option  value="CTX Reflector">CTX Reflector</option>
                                      <option  value="Monitoring">Monitoring</option>
                                    </select>
                                  </div>
                               
                                  <div >
                                    <label className='form-label fw-bolder text-marino fs-6 mb-0 f-parrafo required' htmlFor="company">Additional comments or inquiries:</label>
                                    <textarea  
                                    required
                                    name='commentary' 
                                    className='form-control form-control-solid border-gray-300 f-parrafo' 
                                    id='commentary'
                                    value={commentary}
                                    onChange={(e:any) => setCommentary(e.target.value)}
                                    />
                                  </div>
                               
                               
                                {/* begin::Action */}
                                <br />
                                <div className='d-grid mb-10 justify-content-center'>

                                  <div className='row'>
                                    <div className='col'>
                                      <button
                                          type='submit'
                                          id='kt_sign_in_submit'
                                          className='btn btn-primary'
                                  
                                          
                                        >
                                         Send
                                        </button>
                                    </div>
                                    {/*<div className='col'>
                                        <button
                                        id='kt_sign_in_submit'
                                        className='btn btn-primary'
                                        onClick={() => props.setID(undefined)}

                                        >
                                          Cancel
                                        </button>
    </div>*/}
                                  </div>
                                  
                                  
                                </div>
                                {/* end::Action */}

                            </form>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }   
      
    </>
  )
}
export {Modalmail}